module.exports = __webpack_public_path__ + "images/external_images/img/1200x600/img2.jpg";